module.exports = __webpack_public_path__ + "img/consultative-selling.f1b384c6.png";